module.exports = __webpack_public_path__ + "static/media/event.1889063a.jpg";